// @flow
import type { UserData } from '../../types';
import LocalStorageService from '../../services/localStorageService';
import api from '../../services/api';
import grantAccess from './grantAccess';

export default function login(
  userName: string,
  password: string
): Promise<UserData> {
  return new Promise((resolve, reject) => {
    api.auth
      .login(userName, password)
      .then(response => {
        const { token, verificationType, verificationDetails } = response.data;

        if (verificationType) {
          return resolve({ token, verificationType, verificationDetails });
        }

        grantAccess(token)
          .then((userData: UserData) => resolve(userData))
          .catch(error => {
            LocalStorageService.removeToken();
            reject(error);
          });
      })
      .catch(error => {
        LocalStorageService.removeToken();
        reject(error);
      });
  });
}
